const state = {
  smsApiUrl: '',
  smsApiToken: '',
  custom_status: [],
  custom_messages: [],
  user_phones: [],
  sms_task_messages: [],
  sms_task_active_index: 0,
  campaign: null,
};
var getters = {};
var mutations = {};
var actions = {};

for (let prop in state) {
  //define getters
  getters[prop] = _state => {
    return _state[prop];
  };
  //define muttations
  mutations[`set_${prop}`] = (_state, newValue) => {
    _state[prop] = newValue;
  };
  //define actions
  actions[`set_${prop}`] = (ctx, newValue) => {
    ctx.commit(`set_${prop}`, newValue);
  };
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
